module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignature@2x.521cae5.jpg";